module.exports = __webpack_public_path__ + "img/trump.088f16f2.png";